import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1.638 0L.06 1.599 6.843 8.47 0 15.4 1.579 17 10 8.47 1.638 0z" /></svg>);